import { environment } from '@lla-platform/core/core-util'

export const ANNOUNCEMENTS_API_URL = {
  send: `${environment.apiUrl}/announcements`,
  mine: `${environment.apiUrl}/announcements/mine`,
  unreadCount: `${environment.apiUrl}/announcements/unread-count`,
  markRead: (recipientId: string) => `${environment.apiUrl}/announcements/read/${recipientId}`,
  markUnread: (recipientId: string) => `${environment.apiUrl}/announcements/unread/${recipientId}`,
  archiveMine: (recipientId: string) => `${environment.apiUrl}/announcements/archive/${recipientId}`,
  unarchiveMine: (recipientId: string) => `${environment.apiUrl}/announcements/unarchive/${recipientId}`,
  deleteMine: (recipientId: string) => `${environment.apiUrl}/announcements/mine/${recipientId}`,
  users: `${environment.apiUrl}/announcements/users`,
  adminList: `${environment.apiUrl}/announcements/admin/filters`,
  adminDetail: (id: string) => `${environment.apiUrl}/announcements/admin/${id}`,
  deactivate: (id: string) => `${environment.apiUrl}/announcements/admin/deactivate/${id}`
}
